<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>KPI考核</el-breadcrumb-item>
            <el-breadcrumb-item>不检测列表管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form
            :model="searchForm"
            :inline="true"
            class="demo-form-inline"
            size="small"
          >
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.extype"
                clearable
                size="small"
                placeholder="--请选择类型--"
              >
                <el-option
                  v-for="(item, index) in winOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="quotaSearch"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary" size="small" @click="quotaAdd"
                >添加</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="quotaType" style="width: 100%">
            <el-table-column
              label="编号"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Id }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="类型"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.typeName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="部门"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.MainDeptsName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="岗位"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.DutyName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="人员"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.UserName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建人"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.CreateUserName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="添加时间"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.CreateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="备注"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Remark }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="15%">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row.Id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="添加信息" :visible.sync="dialogFormVisible">
      <el-form :model="dialogForm">
        <el-form-item label="类型">
          <el-select
            filterable
            v-model="dialogForm.ExType"
            clearable
            style="width:90%"
            placeholder="--请选择类型--"
          >
            <el-option
              v-for="(item, index) in winOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="dialogForm.ExType === 0 || dialogForm.ExType === 1">
          <el-row>
            <el-col :span="6">
              <el-container>
                <el-aside style="width:100%;">
                  <el-input
                    style="margin-bottom:12px"
                    size="small"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText"
                  ></el-input>
                  <el-tree
                    class="filter-tree"
                    :data="data"
                    :props="defaultProps"
                    node-key="id"
                    @node-click="handleNodeClick"
                    :filter-node-method="filterNode"
                    ref="tree"
                  >
                    <span class="custom-tree-node" slot-scope="{ node }">
                      <span style="font-size:14px;height:40px;">{{
                        node.label
                      }}</span>
                    </span>
                  </el-tree>
                </el-aside>
              </el-container>
            </el-col>
            <el-col :span="18">
              <el-form-item
                size="small"
                label="部门"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="dialogForm.MainDeptsName"
                  :disabled="true"
                  placeholder="请选择当前部门"
                ></el-input>
              </el-form-item>
              <el-form-item
                size="small"
                label="岗位"
                v-if="dialogForm.ExType === 1"
                :label-width="formLabelWidth"
              >
                <el-select
                  v-model="dialogForm.DutyId"
                  clearable
                  filterable
                  style="float:left;"
                  placeholder="请选择岗位"
                  ref="dutyName"
                >
                  <el-option
                    v-for="item in dutyList"
                    :label="item.Duty"
                    :key="item.Id"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="dialogForm.ExType === 2">
          <el-form-item label="用户">
            <el-input
              v-model="dialogForm.UserName"
              autocomplete="off"
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="工号">
            <el-input
              v-model="dialogForm.UserCode"
              autocomplete="off"
              style="width:90%"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelDialog">取 消</el-button>
        <el-button type="primary" @click="handleChangeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetnoDetection,
  EditSingleNoDetection,
  DeleteSingleNoDetection
} from "../../until/ZeusApiSDK/Logic/KPISettingLogic";
// 获取集团整体架构
import {
  GetDutysByFrameId,
  GetDutysDetail
} from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetFrameTreeList } from "../../until/ZeusApiSDK/Logic/Frame";
export default {
  components: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    quotaType: function() {
      this.tableData.forEach(item => {
        switch (item.ExType) {
          case 0:
            item.typeName = "部门";
            break;
          case 1:
            item.typeName = "岗位";
            break;
          default:
            item.typeName = "个人";
            break;
        }
      });
      return this.tableData;
    }
  },
  data() {
    return {
      winOptions: [
        { label: "部门", value: 0 },
        { label: "岗位", value: 1 },
        { label: "个人", value: 2 }
      ],
      searchForm: {
        extype: ""
      },
      tableData: [],
      pageSizes: [10, 20, 30, 50],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 200,
      // 弹窗dialog
      dialogFormVisible: false,
      form: {},
      param: {},
      user: {},
      dialogForm: {
        id: "",
        ExType: "",
        MainDeptsID: "",
        MainDeptsName: "",
        DutyId: "",
        DutyName: "",
        UserCode: "",
        UserName: "",
        ExUserCode: ""
      },
      dutyList: [],
      formLabelWidth: "120px",
      filterText: "",
      data: [], //树状节点
      defaultProps: {
        children: "children",
        label: "label",
        disabled: "type"
      }
    };
  },
  created() {
    this.GetNoDetectionList();
    this.user = GetCurrentUserInfo();

    //获取部门树状结构信息
    this.GetFrameTree();
  },
  methods: {
    //获取列表API
    GetNoDetectionList: async function() {
      //获取部门信息
      await GetnoDetection(
        this.pageIndex,
        this.pageSize,
        this.searchForm.extype
      ).then(res => {
        console.log("res", res);
        this.tableData = res.Data.DataList;
        this.totalCount = res.Data.totalCount;
      });
    },
    // 添加/编辑API
    EditSingleNoDetection: async function() {
      await EditSingleNoDetection(this.dialogForm).then(res => {
        if (res.Code === 200) {
          this.$message({
            type: "success",
            message: "成功~"
          });
          this.cancelDialog();
          // 刷新列表
          this.GetNoDetectionList();
        } else {
          this.$message({
            type: "error",
            message: res.Msg
          });
        }
      });
    },
    // 删除API
    DeleteSingleNoDetection: async function(userCode, id) {
      await DeleteSingleNoDetection(userCode, id).then(res => {
        if (res.Code === 200) {
          this.$message({
            type: "success",
            message: "删除成功~"
          });
          this.cancelDialog();
          // 刷新列表
          this.GetNoDetectionList();
        } else {
          this.$message({
            type: "error",
            message: res.Msg
          });
        }
      });
    },
    //获取当前部门中心下岗位
    GetDutysByFrameId: function(MainDeptsID) {
      GetDutysByFrameId(MainDeptsID).then(res => {
        this.dutyList = res.list;
      });
    },
    //部门树节点点击
    handleNodeClick: function(data) {
      this.dialogForm.MainDeptsName = data.label;
      this.dialogForm.MainDeptsID = data.Id;
      //获取当前部门中心下岗位
      this.GetDutysByFrameId(this.dialogForm.MainDeptsID);
    },
    //获取部门树
    GetFrameTree: async function() {
      //获取部门信息
      await GetFrameTreeList().then(res => {
        this.data = JSON.parse(res);
      });
    },
    quotaSearch() {
      // 初始化page页面
      this.initPage();
      // 执行搜索api
      this.GetNoDetectionList();
    },
    quotaAdd() {
      this.cancelDialog();
      // 打开弹窗
      this.openDialog();
    },
    handleEdit(index, row) {
      // 获取id,请求内容
      this.dialogForm = {
        id: row.Id,
        ExType: row.ExType,
        MainDeptsID: row.MainDeptsID,
        MainDeptsName: row.MainDeptsName,
        DutyId: row.DutyId,
        DutyName: row.DutyName,
        UserCode: row.UserCode,
        UserName: row.UserName,
        ExUserCode: this.user.UserCode
      };
      // 打开弹窗
      this.openDialog();
      // 点击取消 -> 弹窗清空
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleDelete(index, row) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.DeleteSingleNoDetection(this.user.UserCode, row);
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSizeChange(e) {
      this.initPage();
      this.pageSize = e;
      this.GetNoDetectionList();
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.GetNoDetectionList();
    },
    handleCancelDialog() {
      // 关闭弹窗
      this.cancelDialog();
    },
    handleChangeDialog() {
      console.log();
      if (this.dialogForm.ExType === 1) {
        this.dialogForm.DutyName = this.$refs["dutyName"].query;
      }
      // 上传API--->待开发
      this.EditSingleNoDetection();
    },
    openDialog() {
      // 打开弹窗
      this.dialogFormVisible = true;
    },
    cancelDialog() {
      this.dialogFormVisible = false;
      this.dialogForm = {
        id: "",
        ExType: "",
        MainDeptsID: "",
        MainDeptsName: "",
        DutyId: "",
        DutyName: "",
        UserCode: "",
        UserName: "",
        ExUserCode: this.user.UserCode
      };
    },
    initPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.sub {
  font-size: 12px;
  color: #8f8d8d;
  text-align: left;
  /* margin-top: 10px; */
}
/deep/.contentP {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.mainArea {
  margin: 20px;
  height: 30%;
}
/deep/.bottomInput {
  display: inline;
}
/deep/.web__main-user img {
  margin-top: 18px;
}
</style>
